import { useAsyncFn } from 'react-use-v13';
import { useState } from 'react';
import API from '@scale/frontend-lib/dashboard-api';
import {
  IStellarGenAITask as StellarTask,
  GetStellarGenAITasksByProjectParams,
  GetStellarGenAITasksByProjectQuery,
  GetStellarGenAITasksByProjectRespBody,
} from '@scale/shared/types/stellarGenAITask';

export const useStellarTasks = () => {
  const [data, setData] = useState<StellarTask[]>([]);

  const [getState, executeGet] = useAsyncFn(
    async (
      params?: GetStellarGenAITasksByProjectParams,
      query?: GetStellarGenAITasksByProjectQuery,
    ) => {
      if (!params) {
        return;
      }
      const resp: GetStellarGenAITasksByProjectRespBody =
        await API.genai.getStellarGenAITasksByProject(params, query);
      setData(resp.stellarTasks);
    },
    [],
  );

  return {
    data,
    getState,
    executeGet,
  };
};
